<template>
  <div>
    <v-dialog v-model="showALDialog" persistent scrollable width="800">
      <v-card style="border-radius: 16px">
        <v-card-title
          class="d-flex align-center px-4 justify-space-between"
          style="border-bottom: 1px solid #0000001f;"
        >
          <div>
            <v-icon style="color: #363636" class="mr-1"
              >mdi-plus-box-outline</v-icon
            >
            <span style="font-size: 20px; color: #424242;">{{
              "From Library"
            }}</span>
          </div>
          <v-btn
            icon
            @click="closeALDialog()"
            color="#424242"
            style="
              border-radius: 8px !important;
              border: 1px solid rgba(66, 66, 66, 0.05);
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="height: 800px" class="py-0">
          <v-row class="mt-2">
            <v-col md="6" lg="6" xl="6" sm="12" class="pb-1">
              <v-text-field
                outlined
                dense
                hide-details
                style="border-radius: 8px; border-color: #c0c0c0"
                clearable
                prepend-inner-icon="mdi-magnify"
                placeholder="search..."
                v-model="search"
                class="mb-1"
              >
              </v-text-field>
              <span class="pl-1" style="color: #ff6060; font-size: 18px">
                {{ "** Can select only 1 article" }}</span
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-radio-group name="myGroup">
                <v-data-table
                  :loading="loadingAL"
                  :headers="ArticleHeaders"
                  hide-default-header
                  :items="ArticleList"
                  :search="search"
                  hide-default-footer
                  class="article-table"
                  v-model="selected"
                  item-key="id"
                  disable-pagination
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>
                        <v-radio
                          @change="selectItem(item)"
                          :value="item.contentID"
                          :input-value="selectedItem === item"
                          name="selectedItem"
                          color="#67AB30"
                        ></v-radio>
                      </td>

                      <td>
                        <v-img :src="item.orgImage" class="lessonimg"></v-img>
                      </td>

                      <td>{{ item.contentName }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions
          class="py-3 px-4"
          style="border-top: 1px solid #0000001f;"
        >
          <v-row no-gutters>
            <v-col style="text-align: right">
              <v-btn
                class="text-capitalize"
                style="
                  font-size: 16px;
                  color: #424242;
                  border: 1px solid #c0c0c0;
                  border-radius: 8px;
                "
                width="100"
                text
                @click="showALDialog = false"
                >{{ $t("cancel") }}</v-btn
              >
              <v-btn
                class="text-capitalize ml-2 btn_hover_effect"
                width="100"
                style="
                  font-size: 16px;
                  background: #a6cc39 0% 0% no-repeat padding-box;
                  border-radius: 8px;
                  color: #ffffff;
                "
                @click="save_article()"
                >{{ $t("update") }}</v-btn
              >
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import EnUrl from "@/api/environment";
export default {
  props: {
    // articleItems: {
    //   type: Array,
    // },
    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loadingAL: false,
      ArticleList: [],
      apiUrlV6: EnUrl.apiUrlV6,
      selected: [],
      search: null,
      selectedItem: []
    };
  },

  computed: {
    showALDialog: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("close");
      }
    },
    ArticleHeaders() {
      return [
        {
          text: "",
          align: "start",
          value: "orgImage",
          width: "250px"
        },
        {
          text: this.$t("description"),
          align: "left",
          value: "contentName"
        }
      ];
    }
  },

  mounted() {
    this.getCompanyArticleList();
  },

  methods: {
    async getCompanyArticleList() {
      let self = this;
      let ComId = "00000000-0000-0000-0000-000000000000";
      self.loadingAL = true;
      await axios
        .get(
          `${self.apiUrlV6}Contents/GetArticleByCompanyID?CompanyID=` + ComId
        )
        .then(function(res) {
          self.loadingAL = false;
          if (res.data.data) {
            self.ArticleList = res.data.data ? res.data.data : [];
            // if (self.ArticleList.length != 0) {
            //   console.log("library ", self.ArticleList);
            // }
          }
        })
        .catch(function(err) {
          self.loadingAL = false;
          throw err;
        });
    },
    closeALDialog() {
      this.showALDialog = false;
      this.selectedItem = [];
    },
    selectItem(contentID) {
      this.selectedItem = contentID;
    },
    async save_article() {
      let self = this;
      const data = {
        id: self.selectedItem.contentID
      };

      await axios
        .post(
          `${self.apiUrlV6}AssignmentArticle/AddAssignmentArticleFromLibrary`,
          data
        )
        .then(function(response) {
          if (response.data.status == 0) {
            let result = response.data.data ? response.data.data : [];
            self.$emit("update", result);
          }
        })
        .catch(function(err) {
          throw err;
        });
    }
  }
};
</script>

<style scoped>
.lessonimg {
  width: 192px !important;
  height: 100px !important;
  border-radius: 12px;
}
.article-table.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 16px 10px !important;
}
::v-deep .v-dialog {
  border-radius: 16px;
  overflow-y: hidden !important;
}
::v-deep .v-application .primary--text {
  color: #a6cc39 !important;
  caret-color: #a6cc39 !important;
  border-color: #a6cc39 !important;
}
::v-deep .primary--text {
  color: #a6cc39 !important;
  caret-color: #a6cc39 !important;
  border-color: #a6cc39 !important;
}
</style>
